export default __webpack_public_path__ + "static/media/logo-red2x.ef6e5ef5.png";